import { BaseWebComponentView } from '../../../framework/BaseWebComponentView';
import {
  WEB_COMPONENT_PHASR_RECOMMENDATIONS_GRID,
} from '../../../webcomponents.constants';
import { PhasrRecommendationsGridWebComponent } from '../../phasrRecommendationsGrid';
import { TemplateState } from '../../../types/common/types';

export class PhasrRecommendationsView extends BaseWebComponentView {
  public dom: {
    $wrapper: HTMLElement;
    $phasrRecommendationsGrid: PhasrRecommendationsGridWebComponent;
  };

  getDomElements() {
    this.dom = {
      $wrapper: this.shadow.querySelector('.wrapper'),
      $phasrRecommendationsGrid: this.shadow.querySelector(WEB_COMPONENT_PHASR_RECOMMENDATIONS_GRID),
    };
  }

  public buildSuccessView(data: any) {
    if (!this.dom.$phasrRecommendationsGrid.started) {
      this.dom.$phasrRecommendationsGrid.injectDependencies(this.dependencies);
      this.dom.$phasrRecommendationsGrid.start().then().catch(console.error);
    }
  }

  public setLoadingState(): void {
    this.resetTemplateState(this.dom.$wrapper);
    this.setTemplateState(this.dom.$wrapper, TemplateState.LOADING);
  }

  public removeLoadingState(): void {
    this.resetTemplateState(this.dom.$wrapper);
  }
}
